import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaUniversity, FaCreditCard } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { pontoVirgula, virgulaPonto } from '../../../util/util';
import { FinField, FinInput, FinCheck, FinChecks } from '../../../components/FinField';
import '../../../css/financeiro-parcela-pagar.css';

export default function CadastroCaixa({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({});
    const [tipoRegistro, setTipoRegistro] = useState('banco');
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({ method: "get", action: '/financeiroCaixa/' + id, token: token })
                .then(response => {
                    var dadosRecebidos = response.data.data;
                    // Dados do cartão (pagamento seguro): titular/validade vêm do resumo
                    // mascarado; o número NUNCA volta do backend (só a máscara)
                    if (dadosRecebidos.cartao_info) {
                        dadosRecebidos.cartao_titular = dadosRecebidos.cartao_info.titular || '';
                        dadosRecebidos.cartao_validade = dadosRecebidos.cartao_info.validade || '';
                    }
                    setDados(dadosRecebidos);
                    const temCartao = parseFloat(dadosRecebidos.cartaolimite) > 0 || !!dadosRecebidos.diaCorteCartao;
                    setTipoRegistro(temCartao ? 'cartao' : 'banco');
                })
                .catch(() => {});
        } else {
            setDados({ principal: "nao" });
            setTipoRegistro('banco');
        }
    };

    const alterarTipo = (novoTipo) => {
        setTipoRegistro(novoTipo);
        if (novoTipo === 'banco') {
            const d = JSON.parse(JSON.stringify(dados));
            d.cartaolimite = null;
            d.diaCorteCartao = null;
            d.diaVencimentoCartao = null;
            setDados(d);
        }
    };

    const salvar = () => {
        if (id) {
            api({ method: 'put', action: '/financeiroCaixa/' + id, token: token, data: dados })
                .then(() => history.push("/financeiroCaixa"))
                .catch(() => {});
        } else {
            api({ method: 'post', action: '/financeiroCaixa', token: token, data: dados })
                .then(() => history.push("/financeiroCaixa"))
                .catch(() => {});
        }
    };

    useEffect(() => {
        document.querySelector("#nome") && document.querySelector("#nome").focus();
        buscar();
    },
    // eslint-disable-next-line
    []);

    const ehCartao = tipoRegistro === 'cartao';

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">{ehCartao ? 'Cartão de Crédito' : 'Conta / Caixa'}</h1>
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: '20px 24px', marginBottom: 16 }}>

                        {/* Tipo */}
                        <div style={{ marginBottom: 20 }}>
                            <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--fin-mt)', textTransform: 'uppercase', letterSpacing: '.04em', display: 'block', marginBottom: 8 }}>
                                Tipo de registro
                            </span>
                            <div className="fin-pp__tabs">
                                <button
                                    type="button"
                                    className={'fin-pp__tab' + (!ehCartao ? ' is-active' : '')}
                                    onClick={() => alterarTipo('banco')}
                                >
                                    <FaUniversity size={13} style={{ marginRight: 6 }} />
                                    Conta Bancária / Caixa
                                </button>
                                <button
                                    type="button"
                                    className={'fin-pp__tab' + (ehCartao ? ' is-active' : '')}
                                    onClick={() => alterarTipo('cartao')}
                                >
                                    <FaCreditCard size={13} style={{ marginRight: 6 }} />
                                    Cartão de Crédito
                                </button>
                            </div>
                        </div>

                        {/* Nome + Principal */}
                        <div className="fin-pp__filters">
                            <FinField label={ehCartao ? 'Nome do cartão (ex: Visa Axis, Amex Corp)' : 'Nome da conta (ex: Banco do Brasil, Caixa Empresarial)'} full>
                                <FinInput
                                    id="nome"
                                    value={dados.nome || ''}
                                    onChange={e => setDados({ ...dados, nome: e.target.value })}
                                />
                            </FinField>
                            <FinField label="Opções">
                                <FinChecks>
                                    <FinCheck
                                        id="principal"
                                        label="Principal"
                                        checked={dados.principal === "sim"}
                                        onChange={() => setDados({ ...dados, principal: dados.principal === "sim" ? "nao" : "sim" })}
                                    />
                                </FinChecks>
                            </FinField>
                        </div>

                        {/* Dados bancários — o rodapé que a ND imprime
                            ("Banco: Itau · Agência: 0383 · Conta Corrente: 12195-1").

                            Cartão de crédito não tem agência/conta, mas o bloco aparece nos
                            DOIS tipos e só fica vazio no cartão, em vez de sumir. Motivo: o
                            tipo aqui é ADIVINHADO (`cartaolimite > 0`, no `buscar`), e nesta
                            base os cinco registros têm limite 100000 — inclusive "Banco Itaú"
                            e "Banco Santander", que por isso abrem como cartão. Escondendo o
                            bloco por esse palpite, justamente as contas que precisam do rodapé
                            ficariam sem onde preencher. Coluna é nullable: cartão salva null. */}
                        <div style={{ marginTop: 20 }}>
                            <div className="fin-pp__cphead" style={{ marginBottom: 6 }}>
                                <span className="fin-pp__cphead-ic"><FaUniversity size={14} /></span>
                                <div>
                                    <div className="fin-pp__cphead-title">Dados bancários</div>
                                    <div className="fin-pp__cphead-sub">
                                        {ehCartao
                                            ? 'Cartão de crédito não tem agência nem conta — deixe em branco. Só preencha se este registro for, na verdade, uma conta que recebe pagamento de cliente.'
                                            : 'Saem impressos no rodapé da Nota de Débito dos clientes que recebem nesta conta. Em branco, a ND sai sem o rodapé bancário.'}
                                    </div>
                                </div>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Agência">
                                    <FinInput
                                        id="agencia"
                                        maxLength={20}
                                        placeholder="0383"
                                        value={dados.agencia || ''}
                                        onChange={e => setDados({ ...dados, agencia: e.target.value })}
                                    />
                                </FinField>
                                <FinField label="Conta corrente">
                                    <FinInput
                                        id="conta"
                                        maxLength={30}
                                        placeholder="12195-1"
                                        value={dados.conta || ''}
                                        onChange={e => setDados({ ...dados, conta: e.target.value })}
                                    />
                                </FinField>
                            </div>
                        </div>

                        {/* Saldo + campos exclusivos de cartão.
                            O wrapper acima quebra a adjacência `.fin-pp__filters +
                            .fin-pp__filters` do CSS, então os 16px vêm daqui — senão o Saldo
                            cola na Agência. */}
                        <div className="fin-pp__filters" style={{ marginTop: 16 }}>
                            <FinField label={ehCartao ? 'Saldo disponível no cartão' : 'Saldo disponível na conta'}>
                                <FinInput
                                    id="cartaosaldo"
                                    value={pontoVirgula(dados.cartaosaldo)}
                                    onChange={e => setDados({ ...dados, cartaosaldo: virgulaPonto(e.target.value) })}
                                    style={{ textAlign: 'right' }}
                                />
                                <span style={{ fontSize: 11, color: 'var(--fin-mt)', marginTop: 4, display: 'block' }}>
                                    Atualizar manualmente após movimentações.
                                </span>
                            </FinField>

                            {ehCartao && (
                                <>
                                    <FinField label="Limite total do cartão">
                                        <FinInput
                                            id="cartaolimite"
                                            value={pontoVirgula(dados.cartaolimite)}
                                            onChange={e => setDados({ ...dados, cartaolimite: virgulaPonto(e.target.value) })}
                                            style={{ textAlign: 'right' }}
                                        />
                                    </FinField>
                                    <FinField label="Dia de corte">
                                        <FinInput
                                            id="diaCorteCartao"
                                            type="number"
                                            min={1}
                                            max={31}
                                            value={dados.diaCorteCartao || ''}
                                            onChange={e => setDados({ ...dados, diaCorteCartao: e.target.value })}
                                            style={{ textAlign: 'right' }}
                                        />
                                    </FinField>
                                    <FinField label="Dia vencimento fatura">
                                        <FinInput
                                            id="diaVencimentoCartao"
                                            type="number"
                                            min={1}
                                            max={31}
                                            value={dados.diaVencimentoCartao || ''}
                                            onChange={e => setDados({ ...dados, diaVencimentoCartao: e.target.value })}
                                            style={{ textAlign: 'right' }}
                                        />
                                    </FinField>
                                </>
                            )}
                        </div>

                        {/* Dados do cartão — pagamento seguro ao operador */}
                        {ehCartao && (
                            <div style={{ marginTop: 20 }}>
                                <div className="fin-pp__cphead" style={{ marginBottom: 6 }}>
                                    <span className="fin-pp__cphead-ic"><FaCreditCard size={14} /></span>
                                    <div>
                                        <div className="fin-pp__cphead-title">Dados do cartão — pagamento seguro</div>
                                        <div className="fin-pp__cphead-sub">
                                            Usados para enviar o cartão ao operador sem redigitar (Contas Pendentes / Efetivo).
                                            Ficam criptografados. O CVV não é armazenado — é digitado só na hora do envio.
                                        </div>
                                    </div>
                                </div>
                                <div className="fin-pp__filters">
                                    <FinField label={dados.cartao_info?.mascara
                                        ? `Número — cadastrado ${dados.cartao_info.mascara} (preencha p/ substituir)`
                                        : 'Número do cartão'} grow>
                                        <FinInput
                                            id="cartao_numero"
                                            placeholder="0000 0000 0000 0000"
                                            inputMode="numeric"
                                            maxLength={23}
                                            value={dados.cartao_numero || ''}
                                            onChange={e => {
                                                const dig = e.target.value.replace(/\D/g, '').slice(0, 19);
                                                const masked = dig.replace(/(\d{4})(?=\d)/g, '$1 ');
                                                setDados({ ...dados, cartao_numero: masked });
                                            }}
                                        />
                                    </FinField>
                                    <FinField label="Titular (nome impresso)" grow>
                                        <FinInput
                                            id="cartao_titular"
                                            value={dados.cartao_titular || ''}
                                            onChange={e => setDados({ ...dados, cartao_titular: e.target.value })}
                                        />
                                    </FinField>
                                    <FinField label="Validade (MM/AA)">
                                        <FinInput
                                            id="cartao_validade"
                                            placeholder="MM/AA"
                                            inputMode="numeric"
                                            maxLength={5}
                                            value={dados.cartao_validade || ''}
                                            onChange={e => {
                                                const dig = e.target.value.replace(/\D/g, '').slice(0, 4);
                                                const masked = dig.length > 2 ? dig.slice(0, 2) + '/' + dig.slice(2) : dig;
                                                setDados({ ...dados, cartao_validade: masked });
                                            }}
                                        />
                                    </FinField>
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall">
                            <FaSave size={16} /> Salvar
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
